var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "46.771px",
    viewBox: "0 0 48 46.771",
    enableBackground: "new 0 0 48 46.771",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#330000",
    d: "M8.5-0.014h31c4.7,0,8.5,3.8,8.5,8.5v29.8c0,4.699-3.8,8.5-8.5,8.5h-31c-4.7,0-8.5-3.801-8.5-8.5v-29.8 C0,3.786,3.8-0.014,8.5-0.014z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9A00",
    d: "M23.2,27.985h-7.44l-1.521,4.7c-0.04,0.181-0.2,0.3-0.38,0.28H10.1c-0.22,0-0.28-0.12-0.22-0.359 l6.44-18.541c0.06-0.2,0.12-0.42,0.2-0.66c0.08-0.42,0.12-0.86,0.12-1.3c-0.02-0.1,0.06-0.2,0.16-0.22h5.18 c0.16,0,0.24,0.06,0.26,0.16l7.3,20.6c0.06,0.221,0,0.32-0.2,0.32h-4.18c-0.141,0.02-0.28-0.08-0.32-0.221L23.2,27.985z  M16.92,23.926H22c-0.12-0.42-0.28-0.92-0.46-1.44c-0.18-0.54-0.36-1.12-0.54-1.72c-0.2-0.62-0.38-1.22-0.58-1.84 c-0.2-0.62-0.38-1.2-0.54-1.78c-0.16-0.56-0.3-1.08-0.44-1.56H19.4c-0.18,0.86-0.4,1.72-0.68,2.58c-0.3,0.96-0.6,1.96-0.92,2.96 C17.52,22.146,17.22,23.086,16.92,23.926z M34,15.386c-0.66,0.02-1.3-0.24-1.779-0.7c-0.461-0.5-0.701-1.16-0.681-1.84 c-0.021-0.68,0.239-1.32,0.72-1.78s1.12-0.7,1.78-0.7c0.78,0,1.38,0.24,1.819,0.7c0.44,0.48,0.681,1.12,0.66,1.78 c0.021,0.68-0.22,1.34-0.699,1.84C35.359,15.166,34.68,15.426,34,15.386z M31.76,32.745V17.346c0-0.2,0.08-0.28,0.26-0.28h3.961 c0.18,0,0.26,0.1,0.26,0.28v15.399c0,0.221-0.08,0.32-0.26,0.32h-3.92C31.859,33.065,31.76,32.946,31.76,32.745z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolai);
export default __webpack_public_path__ + "static/media/toolai.d89af4b881329183d58d0eb87d498a4d.svg";
export { ForwardRef as ReactComponent };